// extracted by mini-css-extract-plugin
module.exports = {"button":"jgp-1517E","facebookButtonText":"jgp-3pULw"};